import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 00E1BEF8-DD84-4DCE-BE3C-8AA411DCE5FD
 * name circle-outline
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/circle-outline.svg
 * tags
 * - Shape 
 */
export const CircleOutlineIcon = createSvgIcon(<><path d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></>, 'CircleOutlineIcon');
export default CircleOutlineIcon